import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'

const defaultPhoneErrorMessage = 'The phone number is invalid, please re-enter'
export const phoneErrorMap = {
  INVALID_COUNTRY_CODE: 'Invalid country code',
  TOO_SHORT: 'The phone number is too short, please re-enter',
  TOO_LONG: 'The phone number is too long, please re-enter',
  INVALID_LENGTH: 'The phone number is invalid number, please re-enter',
  IS_POSSIBLE_LOCAL_ONLY: 'The phone number is invalid number, please re-enter',
}

function getPhoneErrorMessage(errorCode) {
  return phoneErrorMap[errorCode] || defaultPhoneErrorMessage
}

export function validateInput(iti, phoneInputTarget, errorMsgTarget, validMsgTarget) {
  resetValidations(phoneInputTarget, errorMsgTarget, validMsgTarget)

  if (!phoneInputTarget.value.trim()) {
    return true
  }

  if (iti.isValidNumber()) {
    validMsgTarget.classList.remove('hide')
    return true
  } else {
    const errorCode = iti.getValidationError()

    phoneInputTarget.classList.add('field_with_errors')
    errorMsgTarget.innerHTML = getPhoneErrorMessage(errorCode)
    errorMsgTarget.classList.remove('hide')
    return false
  }
}

export function resetValidations(phoneInputTarget, errorMsgTarget, validMsgTarget) {
  phoneInputTarget.classList.remove('field_with_errors')
  errorMsgTarget.innerHTML = ''
  errorMsgTarget.classList.add('hide')
  validMsgTarget.classList.add('hide')
}

export function loadPhoneInput(
  phoneInputTarget,
  country,
  errorMsgTarget,
  validMsgTarget,
) {
  const iti = intlTelInput(phoneInputTarget, {
    separateDialCode: true,
    initialCountry: country,
    preferredCountries: [country],
    hiddenInput: () => ({ phone: 'phone_intl_tel_output' }),
    formatOnDisplay: true,
    strictMode: false,
    strictRejectAnimation: false,
  })

  phoneInputTarget.addEventListener('blur', () => {
    validateInput(iti, phoneInputTarget, errorMsgTarget, validMsgTarget)
  })
  phoneInputTarget.addEventListener('change', () => {
    resetValidations(phoneInputTarget, errorMsgTarget, validMsgTarget)
  })
  phoneInputTarget.addEventListener('keyup', () => {
    resetValidations(phoneInputTarget, errorMsgTarget, validMsgTarget)
  })

  return iti
}
